var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidClockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5583C19 15.5263 14.968 19.5583 10 19.5583C5.032 19.5583 1 15.5263 1 10.5583C1 5.59032 5.032 1.55832 10 1.55832C14.968 1.55832 19 5.59032 19 10.5583Z",
    fill: "#E02020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4234 13.5416L9.8401 12C9.3901 11.7333 9.02344 11.0916 9.02344 10.5666V7.14996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidClockFilled);
export default __webpack_public_path__ + "static/media/bfid-clock-filled.6cd4d1ebf863001776e05dc959aa543c.svg";
export { ForwardRef as ReactComponent };